"use client";

import { useRouter } from "next/router";
import Script from "next/script";
import { useEffect } from "react";

//#region [Component]
export default function ScriptOnNav() {
    const router = useRouter();

    useEffect(() => {
        const isStreaming = router.pathname.startsWith('/streamingguide');
        const scriptId = 'atmng-script';

        // Remove existing script if any
        const existing = document.getElementById(scriptId);
        if (existing) {
            existing.remove();
        }

        // Create new script
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = isStreaming
            ? 'https://t.atmng.io/filmweb/IvYQJt7vE.prod.js'
            : 'https://t.atmng.io/filmweb/vqcMX_bYS.prod.js';
        script.async = true;
        script.defer = false;
        document.body.appendChild(script);

        // Optional cleanup if you want to remove it on unmount
        return () => {
            script.remove();
        };
    }, [router.pathname]);

    return null;
}
